import PropTypes from 'prop-types';
import PhaseList from './phaseList';
import PhaseNew from './phaseEdit/phaseNew';
import PhaseEdit from './phaseEdit';
import PhaseShow from './phaseShow';
import ui from 'redux-ui';

export * from './phaseShow';

const Phases = ({ children }) => children;

Phases.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ui({
  key: 'phases',
  state: {
    successMessage: '',
    activeTab: '',
    foldersActive: [],
  },
})(Phases);

export { PhaseList, PhaseNew, PhaseEdit, PhaseShow };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/index.jsx